import React, { useState } from 'react';
import { Button, Form, Grid, Header, Input } from 'semantic-ui-react';
import {
  changeEmail,
  verifyEmail,
} from '../../Services/UserProfileService';
import ErrorDisplay from '../Messaging/ErrorDisplay';
import SuccessDisplay from '../Messaging/SuccessDisplay';
const ChangeEmail: React.FunctionComponent = () => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [changeEmailSuccessMessage, setchangeEmailSuccessMessage] = useState(
    '',
  );
  const [verificationSuccessMessage, setVerificationSuccessMessage] = useState(
    '',
  );

  const [showVerify, setShowVerify] = useState(false);
  const [code, setCode] = useState(0);

  const onChangeEmailClick = async () => {
    try {
      setErrorMessage('');
      setchangeEmailSuccessMessage('');
      setVerificationSuccessMessage('');
      await changeEmail(email);
      setShowVerify(true);
      setchangeEmailSuccessMessage(
        'Your email has been changed. Please check your new email address for verification code.',
      );
    } catch (error: any) {
      setErrorMessage(error.message);
    }
  };

  const onVerifyClick = async () => {
    try {
      setErrorMessage('');
      setVerificationSuccessMessage('');
      await verifyEmail(code);
      setVerificationSuccessMessage('Thank you for verifying your email.');
    } catch (error: any) {
      setErrorMessage(error.message);
    }
  };

  return (
    <>
      <Header>Change Email</Header>
      <Form>
        <Grid columns={1}>
          <Grid.Row>
            <Grid.Column>
              <Form.Field>
                <label>New Email</label>
                <Input
                  placeholder="New Email"
                  onChange={(e) => setEmail(e.target.value)}
                  fluid
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Button
                onClick={onChangeEmailClick}
                primary
                style={{ width: '12em' }}
              >
                Change Email
              </Button>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row></Grid.Row>
          {showVerify && (
            <>
              <Grid.Column>
                <SuccessDisplay message={changeEmailSuccessMessage} />
              </Grid.Column>
              <Grid.Row>
                <Grid.Column>
                  <Input
                    placeholder="Code"
                    onChange={(e) => setCode(+e.target.value)}
                    fluid
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Button
                    onClick={onVerifyClick}
                    primary
                    style={{ width: '12em' }}
                  >
                    Verify
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </>
          )}
          <Grid.Row>
            <Grid.Column>
              <ErrorDisplay message={errorMessage} />
              <SuccessDisplay message={verificationSuccessMessage} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </>
  );
};

export default ChangeEmail;
